import { Card } from "antd";
import styled from "styled-components";

export const StyledCard = styled(Card)`
  .ant-collapse-header {
    padding: 0;
  }
  .ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {
    padding: 1em 0 0 0;
  }
  .ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 0;
  }
  .ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
    right: 0;
  }
  .ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {
    padding-left: 0;
  }
  .ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header {
    padding: 14px 40px 0px 0px;
`;
